import { render, staticRenderFns } from "./DiagnosticAccount.vue?vue&type=template&id=61e5235d"
import script from "./DiagnosticAccount.vue?vue&type=script&lang=js"
export * from "./DiagnosticAccount.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticAccount.vue?vue&type=style&index=0&id=61e5235d&prod&lang=scss"
import style1 from "./DiagnosticAccount.vue?vue&type=style&index=1&id=61e5235d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports